import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    domains: [],
    fetching: true,
    selected: null
  },
  mutations: {
    set (state, domains) {
      state.domains = domains
    },
    setSelected (state, domain) {
      state.selected = domain
    }
  },
  actions: {
    fetch ({ state, commit }) {
      state.fetching = true
      apiService.getDomains()
        .then(response => {
          commit('set', response.data)
          window.vue.$emit('serm/domainsLoaded')
          state.fetching = false
        })
        .catch(() => {
          state.fetching = false
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список доменов.'
          })
        })
    },
    changeSelected ({ state, commit, dispatch }, selected) {
      commit('setSelected', selected)
      window.vue.$emit('serm/domainSelected')
    }
  }
}
